import React from "react";
import DashboardComponent from "../components/dashboard/DashboardComponent";

export default function Dashboard() {
  return (
    <div>
      <DashboardComponent />
    </div>
  );
}
